import { LanguagesEnum } from 'constants/languages';
import moment from 'moment';
import 'moment/locale/el'; // without this line it didn't work

export const formatDate = (datetime: string): string | null => {
  try {
    const date = new Date(datetime);
    const daysTemp = date.getDate();
    const monthTemp = date.getMonth() + 1;

    const minutes =
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    const hours =
      date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    const day = daysTemp < 10 ? `0${daysTemp}` : daysTemp;
    const month = monthTemp < 10 ? `0${monthTemp}` : monthTemp;

    return `${day}-${month}-${date.getFullYear()} ${hours}:${minutes}`;
  } catch (error) {
    return null;
  }
};

export const datetimeToString = (
  datetime: string | Date,
  includeDate: boolean = true,
  includeTime: boolean = true
): string | null => {
  try {
    const date = new Date(datetime);
    let result = '';

    // DATE
    var datePart = `${date.getDate()}`;
    if (Number.parseInt(datePart) < 10) datePart = `0${datePart}`;
    var monthPart = `${date.getMonth() + 1}`;
    if (Number.parseInt(monthPart) < 10) monthPart = `0${monthPart}`;
    var yearPart = `${date.getFullYear()}`;
    if (includeDate) {
      result += `${datePart}/${monthPart}/${yearPart}`;
    }

    // TIME
    var hoursPart = `${date.getHours()}`;
    if (Number.parseInt(hoursPart) < 10) hoursPart = `0${hoursPart}`;
    var minutesPart = `${date.getMinutes()}`;
    if (Number.parseInt(minutesPart) < 10) minutesPart = `0${minutesPart}`;

    if (includeDate && includeTime) {
      result += ', ';
    }

    if (includeTime) {
      result += `${hoursPart}:${minutesPart}`;
    }

    return result;
  } catch (error) {
    return null;
  }
};

export const timeSince = (date: Date | string) => {
  const _date = new Date(date);
  const currentDate = new Date();
  var seconds = Math.floor((currentDate.valueOf() - _date.valueOf()) / 1000);
  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + ' years ago';
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + ' months ago';
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + ' days ago';
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + ' hours ago';
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + ' minutes ago';
  }
  return Math.floor(seconds) + ' seconds ago';
};

export const formatDateToSQL = (date: Date) => {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
};

export const fromNowWithLanguage = (date: Date, language: LanguagesEnum) => {
  moment.locale(language === LanguagesEnum.Greek ? 'el' : LanguagesEnum.German ? 'de' : LanguagesEnum.Italian ? 'it' : 'en');
  return moment.utc(date).subtract(2, 'h').locale(language).fromNow();
};
